/* tslint:disable */
/* eslint-disable */
/**
 * Hyper-Timesheet.API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface ApprovazioneLavoriDTO
 */
export interface ApprovazioneLavoriDTO {
    /**
     * 
     * @type {number}
     * @memberof ApprovazioneLavoriDTO
     */
    idLavoro?: number;
    /**
     * 
     * @type {string}
     * @memberof ApprovazioneLavoriDTO
     */
    nome?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ApprovazioneLavoriDTO
     */
    numero?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ApprovazioneLavoriDTO
     */
    commessa?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ApprovazioneLavoriDTO
     */
    nota?: string | null;
    /**
     * 
     * @type {number}
     * @memberof ApprovazioneLavoriDTO
     */
    oreLavorate?: number;
    /**
     * 
     * @type {number}
     * @memberof ApprovazioneLavoriDTO
     */
    oreDaStampare?: number | null;
    /**
     * 
     * @type {string}
     * @memberof ApprovazioneLavoriDTO
     */
    cliente?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ApprovazioneLavoriDTO
     */
    tipoIntervento?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof ApprovazioneLavoriDTO
     */
    fatturabile?: boolean | null;
    /**
     * 
     * @type {boolean}
     * @memberof ApprovazioneLavoriDTO
     */
    approvato?: boolean | null;
    /**
     * 
     * @type {number}
     * @memberof ApprovazioneLavoriDTO
     */
    approvatoDa?: number | null;
    /**
     * 
     * @type {Date}
     * @memberof ApprovazioneLavoriDTO
     */
    approvatoIl?: Date | null;
    /**
     * 
     * @type {boolean}
     * @memberof ApprovazioneLavoriDTO
     */
    smartWorking?: boolean;
    /**
     * 
     * @type {Date}
     * @memberof ApprovazioneLavoriDTO
     */
    data?: Date;
    /**
     * 
     * @type {string}
     * @memberof ApprovazioneLavoriDTO
     */
    diaria?: string | null;
}

/**
 * Check if a given object implements the ApprovazioneLavoriDTO interface.
 */
export function instanceOfApprovazioneLavoriDTO(value: object): value is ApprovazioneLavoriDTO {
    return true;
}

export function ApprovazioneLavoriDTOFromJSON(json: any): ApprovazioneLavoriDTO {
    return ApprovazioneLavoriDTOFromJSONTyped(json, false);
}

export function ApprovazioneLavoriDTOFromJSONTyped(json: any, ignoreDiscriminator: boolean): ApprovazioneLavoriDTO {
    if (json == null) {
        return json;
    }
    return {
        
        'idLavoro': json['idLavoro'] == null ? undefined : json['idLavoro'],
        'nome': json['nome'] == null ? undefined : json['nome'],
        'numero': json['numero'] == null ? undefined : json['numero'],
        'commessa': json['commessa'] == null ? undefined : json['commessa'],
        'nota': json['nota'] == null ? undefined : json['nota'],
        'oreLavorate': json['oreLavorate'] == null ? undefined : json['oreLavorate'],
        'oreDaStampare': json['oreDaStampare'] == null ? undefined : json['oreDaStampare'],
        'cliente': json['cliente'] == null ? undefined : json['cliente'],
        'tipoIntervento': json['tipoIntervento'] == null ? undefined : json['tipoIntervento'],
        'fatturabile': json['fatturabile'] == null ? undefined : json['fatturabile'],
        'approvato': json['approvato'] == null ? undefined : json['approvato'],
        'approvatoDa': json['approvatoDa'] == null ? undefined : json['approvatoDa'],
        'approvatoIl': json['approvatoIl'] == null ? undefined : (new Date(json['approvatoIl'])),
        'smartWorking': json['smartWorking'] == null ? undefined : json['smartWorking'],
        'data': json['data'] == null ? undefined : (new Date(json['data'])),
        'diaria': json['diaria'] == null ? undefined : json['diaria'],
    };
}

export function ApprovazioneLavoriDTOToJSON(json: any): ApprovazioneLavoriDTO {
    return ApprovazioneLavoriDTOToJSONTyped(json, false);
}

export function ApprovazioneLavoriDTOToJSONTyped(value?: ApprovazioneLavoriDTO | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'idLavoro': value['idLavoro'],
        'nome': value['nome'],
        'numero': value['numero'],
        'commessa': value['commessa'],
        'nota': value['nota'],
        'oreLavorate': value['oreLavorate'],
        'oreDaStampare': value['oreDaStampare'],
        'cliente': value['cliente'],
        'tipoIntervento': value['tipoIntervento'],
        'fatturabile': value['fatturabile'],
        'approvato': value['approvato'],
        'approvatoDa': value['approvatoDa'],
        'approvatoIl': value['approvatoIl'] == null ? undefined : ((value['approvatoIl'] as any).toISOString()),
        'smartWorking': value['smartWorking'],
        'data': value['data'] == null ? undefined : ((value['data']).toISOString()),
        'diaria': value['diaria'],
    };
}

